/* unplugin-vue-components disabled */import { render } from "./PaymentCalculator.vue?vue&type=template&id=3b0e51fa&scoped=true&ts=true"
import script from "./PaymentCalculator.vue?vue&type=script&lang=ts"
export * from "./PaymentCalculator.vue?vue&type=script&lang=ts"

import "./PaymentCalculator.vue?vue&type=style&index=0&id=3b0e51fa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0e51fa"]])

export default __exports__